module.exports = __webpack_public_path__ + "static/media/speakerFour.6b8b865c.jpg";